<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-search-bar
        :show-currency="false"
        :is-manage-module="true"
        :show-schedule="false"
        :filter="filter"
        source="PriceFCLExtra"
        :source-show-level="false"
        config-id="PriceFCLExtra"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @reset="resetQuery"
      >
        <template v-if="isCp" slot="operations">
          <el-button v-if="inputAllowed_PP" no="onEditCP" type="primary" :disabled="!this.cpSelectRow || selectedCpCount > 1" @click="onEdit_CP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-if="deleteAllowed_CP" no="onDeleteCP" type="danger" :disabled="!selectedCpCount" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
        </template>
        <template v-if="activeTabName === 'ppList'" slot="operations">
          <el-button v-if="inputAllowed_PP" no="onEditPP" type="primary" :disabled="!this.ppSelectRow || selectedPpCount > 1" @click="onEdit_PP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" :disabled="!selectedPpCount" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-if="approveAllowed_PP" no="onApprovePP" type="primary" @click="onApprove_PP()">{{ $t('Pricing.Approve') }}</el-button>
          <el-button v-if="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-if="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-if="inputAllowed_PP"
            no="saveExcelFile"
            :action="URL.price.priceFclExtra.saveExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="officeId"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </fcl-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <fcl-extra-data-grid
            :v-if="isCp"
            source="priceFCLExtra"
            config-module="220601"
            :row-data="rowCpData"
            :show-approve="true"
            :show-branch="false"
            :filter="filter"
            :grid-options="cpGridOptions"
            :show-check-box="true"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <fcl-extra-data-grid
            :v-if="activeTabName === 'ppList'"
            source="priceFCLExtra"
            config-module="220602"
            :row-data="rowPpData"
            :show-approve="false"
            :show-branch="false"
            :filter="filter"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <fcl-extra-form
      :visible="fclExtraFormDialog.visible"
      :price="fclExtraFormDialog.price"
      :is-new="fclExtraFormDialog.isNew"
      :is-cp="isCp"
      @close="onFclFormDialogClose"
      @reload="toQuery"
    />
  </div>
</template>

<script>

import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { getLoading } from '@/utils/utilBaseElement'
import { queryEffectivePriceFclExtra,
  queryPendingPriceFclExtra,
  deletePriceFclExtras,
  approvePriceFclExtras } from '@/api/price/priceFclExtra'
import DateUtils from '@/utils/dateUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import FclExtraDataGrid from '@/views/cargo/v0/Price/components/grid/fclExtraDataGrid'
import FclExtraForm from '@/views/cargo/v0/Price/PriceFCLExtra/components/fclExtraForm'
import { deepClone } from '@/utils'

export default {
  name: 'PriceFCLExtra',
  components: {
    FclExtraForm,
    FclExtraDataGrid,
    FclSearchBar },
  data() {
    return {
      URL,
      globalMsg: '',
      activeTabName: 'cpList',
      isHQManager: false,
      remarkChange: '',
      targetLevel: 99,
      txtRemarks: '',
      showDetail: false,
      showLevel: false,
      fullscreenLoading: null,
      officeId: {},
      proxy: {},
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: null,
        endDate: '',
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        dangerous: false,
        simPol: '',
        simPod: ''
      },
      rowCpData: [],
      rowPpData: [],
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedCpCount = rows.length
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedPpCount = rows.length
        }
      },
      selectedCpCount: 0,
      selectedPpCount: 0,
      fclExtraFormDialog: {
        visible: false,
        price: {},
        isNew: false
      },
      priceStateRejectDialog: {
        visible: false,
        price: {
          reject20: false,
          reject40: false,
          rejectHC: false,
          reject45: false,
          priceFclUuids: []
        }
      },
      fclMarkupSchemeDialog: {
        visible: false,
        selectedRows: []
      },
      fclMarkupManualDialog: {
        visible: false,
        selectedRows: []
      },
      fclSettingsDialog: {
        visible: false
      },
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      priceFclUtil: null
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isCp() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PriceFCLExtra', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      this.officeId['currentOfficeId'] = this.$store.getters.currentOfficeId
      const activeTab = LocalStorageUtils.getConfiguration('PriceFCLExtra')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceFcl')
      this.priceFclUtil = await PricingFCLConfigUtil.getInstance()
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        if (this.isHQManager) {
          this.deleteAllowed_PP = true
        }
        // 改成有批准权限人，就能删除
        this.approveAllowed_PP = this.deleteAllowed_CP = this.priceFclUtil.isApprove
        this.inputAllowed_PP = this.priceFclUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    onFclFormDialogClose() {
      this.fclExtraFormDialog.visible = false
      this.fclExtraFormDialog.data = {}
    },
    onFclMarkupSchemeDialogClose() {
      this.fclMarkupSchemeDialog.visible = false
      this.fclMarkupSchemeDialog.rowData = {}
    },
    onFclMarkupManualDialogClose() {
      this.fclMarkupManualDialog.visible = false
    },
    onFclSettingsDialogClose() {
      this.fclSettingsDialog.visible = false
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      if (this.isCp) {
        queryEffectivePriceFclExtra(this.proxy).then((res) => {
          const _resMap = res.data
          this.fullscreenLoading.close()
          if (_resMap && _resMap.length === 0) {
            this.$message.warning(this.$t('Pricing.NoRecord'))
            this.rowCpData = []
          }
          const count = _resMap.length
          // 只返回部分结果的话，弹窗提醒是否加载更多
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
            this.$confirm(msg, this.$t('Pricing.Tips'), {
              confirmButtonText: this.$t('Pricing.YesLabel'),
              cancelButtonText: this.$t('Pricing.NoLabel'),
              type: 'info',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            }).then(() => {
            }).catch(() => {
              this.proxy.isLimited = false
              this.toQuery(this.proxy)
              return
            })
          }
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            _resMap.pop()
          }
          this.setFrequency(_resMap)
          this.rowCpData = _resMap
          this.clearGridChoose()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        if (!MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')) {
          this.proxy['branchId'] = this.$store.getters.currentOfficeId
        }
        queryPendingPriceFclExtra(this.proxy).then((res) => {
          const _resMap = res.data
          this.fullscreenLoading.close()
          if (_resMap && _resMap.length === 0) {
            this.$message.warning(this.$t('Pricing.NoRecord'))
            this.rowPpData = []
          }
          const count = _resMap.length
          // 只返回部分结果的话，弹窗提醒是否加载更多
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
            this.$confirm(msg, this.$t('Pricing.Tips'), {
              confirmButtonText: this.$t('Pricing.YesLabel'),
              cancelButtonText: this.$t('Pricing.NoLabel'),
              type: 'info',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            }).then(() => {
            }).catch(() => {
              this.proxy.isLimited = false
              this.toQuery(this.proxy)
              return
            })
          }
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            _resMap.pop()
          }
          this.setFrequency(_resMap)
          this.rowPpData = _resMap
          this.clearGridChoose()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    setFrequency(list) {
      if (!list) {
        return
      }
      for (const d of list) {
        if (!d.frequency) {
          d.frequency = PriceUtils.frequencyLabelFunc(d, 'frequency')
        }
      }
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.isCp) {
        this.cpSelectRow = data
        this.onEdit(this.cpSelectRow)
      } else {
        this.ppSelectRow = data
        this.onEdit(this.ppSelectRow)
      }
    },
    onEdit_CP() {
      const newPrice = deepClone(this.cpSelectRow)
      delete newPrice['uuid']
      delete newPrice['dateCreated']
      this.onEdit(newPrice)
    },
    onEdit_PP() {
      this.onEdit(this.ppSelectRow)
    },
    onEdit(data) {
      if (!data) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.fclExtraFormDialog.visible = true
      this.fclExtraFormDialog.isNew = false
      this.fclExtraFormDialog.price = deepClone(data)
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (!selectedRows) {
        return
      }
      const ids = []
      for (const row of selectedRows) {
        ids.push(row.uuid)
      }
      this.onDelete(ids)
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.cpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      if (!this.isHQManager) {
        for (const item of selectedRows) {
          if (item.branchId !== this.$store.getters.currentOfficeId) {
            this.$message.warning(this.$t('Pricing.IsAllowedOperate_DiffBranch'))
            return null
          }
        }
      }
      return selectedRows
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    onDelete(ids) {
      this.$confirm(this.$t('Pricing.IsDeleteRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        deletePriceFclExtras(ids).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
            if (this.isCp) {
              const { api } = this.cpGridOptions
              api.updateRowData({ remove: api.getSelectedRows() })
            } else {
              const { api } = this.ppGridOptions
              api.updateRowData({ remove: api.getSelectedRows() })
            }
            this.clearGridChoose()
          }
        })
      })
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRowsPp()
      if (!selectedRows) {
        return
      }
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      const ids = this.getSelectUuids(selectedRows)
      this.onDelete(ids)
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 审核
    onApprove_PP() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsApproveRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        approvePriceFclExtras(selectedRows, { state: PriceConstant.PRICE_STATE_EFFECTIVE }).then(res => {
          this.$message.success(this.$t('Pricing.HasApproved'))
          this.ppGridOptions.api.updateRowData({ remove: selectedRows })
        })
      })
    },
    onAdd_PP() {
      this.fclExtraFormDialog.visible = true
      this.fclExtraFormDialog.isNew = true
      this.fclExtraFormDialog.price = {
        freightType: PriceConstant.PRICE_TYPE_ALL.code,
        state: PriceConstant.PRICE_STATE_PENDING,
        freeContainerPeriodType: PriceConstant.FREE_TIME_CONSOLIDATE.code,
        freeTimeNil: false,
        currency: '',
        shareCarrier: '',
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false,
        freeContainerPeriod: '',
        dem: '',
        det: ''
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('FCL_Extra_sample.xls', 'price')
    },
    selectRowChange(data) {
      if (this.isCp) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    clearGridChoose() {
      if (this.isCp) {
        this.cpSelectRow = null
        this.cpGridOptions.api.clearFocusedCell()
      } else {
        this.ppSelectRow = null
        this.ppGridOptions.api.clearFocusedCell()
      }
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        return
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    },
    resetQuery() {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = null
        this.rowCpData = []
      } else {
        this.ppSelectRow = null
        this.selectedPpCount = 0
        this.rowPpData = []
      }
      this.globalMsg = ''
    }
  }
}
</script>

<style scoped>

</style>
